import { BaseCaller } from "./api";

export default class AdminApi {
  private caller: BaseCaller;

  constructor(caller: BaseCaller) {
    this.caller = caller;
  }

  public list(): Promise<any> {
    return this.caller.get("admin/");
  }

  add(data: { name: string; pass: string; email: string }) {
    return this.caller.post("admin/", data);
  }

  addExtended(data: {
    name: string;
    pass: string;
    email: string;
    branch: number;
  }) {
    return this.caller.post("admin/addExtended", data);
  }

  updateBranch(adminId: number, branch: number) {
    return this.caller.put(`admin/${adminId}/addBranch/${branch}`, {});
  }

  disable(id: string) {
    return this.caller.post(`admin/${id}/inactivate`, {});
  }

  activate(id: string) {
    return this.caller.post(`admin/${id}/activate`, {});
  }

  clientLocationByDocument(document: string): Promise<any> {
    return this.caller.get(`admin/location/byClientDocument/${document}`);
  }
}



// WEBPACK FOOTER //
// ./src/api/admin-api.ts